import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchSupportPoolsTypes,
  fetchMessagesTypes,
  acceptSupportTypes,
  resolveSupportTypes,
  unresolveSupportTypes,
  SELECT_SUPPORT_POOL_USER,
  SET_LAST_MESSAGES,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const main = makeRequestReducer({
  types: fetchSupportPoolsTypes,
  name: 'adminSupportPools',
  mutate: (state, res) => keyBy(res, '_id'),
  append: [
    makeRequestReducer({
      types: acceptSupportTypes,
      name: 'acceptCustomerSupport',
      mutate: (state, res) => ({ ...state.data, [res._id]: res }),
    }),
    makeRequestReducer({
      types: resolveSupportTypes,
      name: 'resolveCustomerSupport',
      mutate: (state, res) => ({ ...state.data, [res._id]: res }),
    }),
    makeRequestReducer({
      types: unresolveSupportTypes,
      name: 'unresolveCustomerSupport',
      mutate: (state, res) => ({ ...state.data, [res._id]: res }),
    }),
  ],
});

const single = makeRequestReducer({
  types: fetchMessagesTypes,
  name: 'adminCustomerSupportMessages',
});

const selectedInitialState = {
  selected: ''
};

const selected = (state = selectedInitialState, action) => {
  switch (action.type) {
    case SELECT_SUPPORT_POOL_USER:
      return { ...state, selected: action.payload };
    default:
      return state;
  }
};

const lastMessages = (state = {}, action) => {
  switch (action.type) {
    case SET_LAST_MESSAGES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default combineReducers({
  main,
  single,
  selected,
  lastMessages,
});



// WEBPACK FOOTER //
// ./src/modules/messages/reducers.js